import { connect } from "react-redux";
import IAppState from "../../redux/types/IAppState";
import { Dispatch } from "redux";
import { HomePage } from "./HomePage";
import {
    triggerManualJob,
    getCWRAckHWM,
    getAutomaticAgreementGHWM,
    getManualJobDataSources,
    searchContributorsThunk,
    getMenuItemsThunk
} from "../../redux/thunks/HomeThunks";
import { resetPaginationHomeModal, setCurrentPage, updateCMUContributors, updateManualJobParams, updatePaginationHomeModal } from "../../redux/reducers/HomeReducer";
import { getPaymentRunIDsThunk } from "../../redux/thunks/RepertoireThunks";
import { showModal } from "../../redux/reducers/ModalReducer";
import { clearModalSearchResultsThunk } from "../../redux/thunks/ModalThunks";
import { ITriggerManualJob } from "../../redux/types/ITriggerManualJob";
import { IContributorSearchQuery } from "../../repertoire/types/IContributorSearchQuery";
import { getMyApplicationsThunk, getMyCasesThunk, getCRMIntegratedEnabledThunk, getCurrentUserSocietyAffiliationThunk, getViewAsAccessRequestsThunk, fetchMembersPortalUserRolesThunk, loadMembersPortalFromPathThunk } from "../../redux/thunks/MembersPortalThunks";
import { IMembersPortalPathInfo } from "../../membersportal/types/IMembersPortalPathInfo";
import { getViewAsAccessRequests } from "../../redux/reducers/MembersPortalReducer";

export default connect(
    (state: IAppState) => ({
        lookups: state.lookupEntities,
        componentData: state.home.componentData,
        users: state.account.users,
        jobSearchState: state.home.jobSearchState,
        jobSearchResults: state.home.jobSearchResults,
        currentPage: state.home.currentPage,
        enableModules: state.home.enableModules,
        defaultActiveAccordions: state.repertoire.defaultActiveAccordions,
        resultsPerPage: state.home.resultsPerPage,
        displayModal: state.modal.displayModal,
        modalContent: state.modal.modalContent,
        modalProps: state.modal.modalProps,
        modalComponentInstance: state.modal.modalComponentInstance,
        modalTitle: state.modal.title,
        displayModalCloseButton: state.modal.displayModalCloseButton,
        manualJobParameters: state.home.manualJobParameters,
        manualJobType: state.home.manualJobType,
        manualJobDataSources: state.home.manualJobDataSources,
        cwrAckHWM: state.home.cwrAckHWM,
        atomaticAgreementGHWM: state.home.automaticAgreementGHWM,
        paymentRunIDs: state.repertoire.paymentRunIDs,
        shortCutKeys: state.repertoire.shortCutKeys,
        searchViewData: state.home?.componentData?.SearchView,
        dataSource: state.home?.dataSource,
        searchResultsTableData: state.home?.componentData?.SearchResultsTable,
        contributorsSearchResults: state.home.contributorsSearchResult,
        searchSuccessful: state.home.searchSuccessful,
        portalType: state.account.portalType,
        client: state.account.client,
        username: state.account.currentUser,
        currentUserNameNumber: state.account.currentUserNameNumber,
        currentViewAsUserName: state.account.currentViewAsUserName,
        myApplications: state.membersPortal.myApplications,
        myCases: state.membersPortal.myCases,
        membersPortalSearchResultsTableData: state.membersPortal?.componentData?.SearchResultsTable,
        isCRMIntegrationEnabled: state.membersPortal.isCRMIntegrationEnabled,
        powerPortalURL: state.membersPortal.powerPortalURL,
        customerDatePreference: state.account.customerDate,
        viewAsAccessRequests: state.membersPortal.viewAsAccessRequests,
        customerTimeZonePreference: state.account.customerTimeZone,
        enableMemberNumber:state.account.enableMemberNumber,
        modalIndex: state.modal.index,
        customerTerritory:state.account.allocationCustomerTerritory,
        customer: state.account.customer,
        accountSocietyAffiliation: state.account.accountSocietyAffiliation,
    }),
    (dispatch: Dispatch) => ({
        setCurrentPage: (link: string) => dispatch(setCurrentPage(link)),
        hideModal: () => dispatch<any>(clearModalSearchResultsThunk()),
        showModal: (
            modalContent: string,
            modalComponentInstance: string,
            modalProps: any,
            displayModalCloseButton: boolean,
            title: string
        ) =>
            dispatch(
                showModal(modalContent, modalComponentInstance, modalProps, displayModalCloseButton, title)
            ),
        triggerManualJob: (manualJob: ITriggerManualJob) => dispatch<any>(triggerManualJob(manualJob)),
        getCWRAckHWM: () => dispatch<any>(getCWRAckHWM()),
        getAutomaticAgreementGHWM: () => dispatch<any>(getAutomaticAgreementGHWM()),
        fetchManualJobDataSources: () => dispatch<any>(getManualJobDataSources()),
        getPaymentRunIDs: () => dispatch<any>(getPaymentRunIDsThunk()),
        searchContributors: (query: IContributorSearchQuery) =>
            dispatch<any>(searchContributorsThunk(query)),
        updateManualJobParams: (params: any) => dispatch(updateManualJobParams(params)),
        resetPagination: (repertoireSection: string) => dispatch(resetPaginationHomeModal(repertoireSection)),
        updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => dispatch<any>(updatePaginationHomeModal(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection)),
        loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => dispatch<any>(loadMembersPortalFromPathThunk(pathInfo, currentUserNameNumber, location)),
        updateCMUContributors: (cmuContributors: any[], modalIndex?: number) => dispatch(updateCMUContributors(cmuContributors, modalIndex)),
        refreshMyCases: () => dispatch<any>(getMyCasesThunk()),
        refreshMyApplications: () => dispatch<any>(getMyApplicationsThunk()),
        getCurrentUserSocietyAffiliation: () => dispatch<any>(getCurrentUserSocietyAffiliationThunk()),
        getMenuItems: (portalType: string) => dispatch<any>(getMenuItemsThunk(portalType)),
		getViewAsAccessRequests: (currentUser: string) => dispatch<any>(getViewAsAccessRequestsThunk(currentUser))
    })
)(HomePage); 